import { ElementType, useCallback, useState } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

import { Sidebar } from './Sidebar'
import { MobileHeader } from './MobileHeader'

type NavigationProps = {
    Header?: ElementType
    Canvas?: ElementType
}

export const Navigation = observer(({ Header, Canvas }: NavigationProps) => {
    const [open, setOpen] = useState(false)

    const handleToggleOpen = useCallback(() => {
        setOpen((o) => !o)
    }, [])

    const [collapsed, setCollapsed] = useState(localStorage.getItem('sidebarCollapsed') === 'true' || false)

    const handleToggleCollapsed = useCallback(() => {
        setCollapsed(!collapsed)
        localStorage.setItem('sidebarCollapsed', (!collapsed).toString())
    }, [collapsed])

    return (
        <nav
            className={classNames(
                'z-10 flex flex-col overflow-hidden shadow-sm md:z-0 md:h-full md:shrink-0 md:bg-transparent md:shadow-none',
                {
                    'h-full': open,
                    'md:w-[256px]': !collapsed,
                    'md:w-[56px]': collapsed,
                }
            )}
        >
            <MobileHeader open={open} onToggleOpen={setOpen} />
            <div className="flex flex-1 overflow-hidden">
                <div className="flex-1 shrink-0 overflow-auto">
                    <Sidebar
                        Header={Header}
                        Canvas={Canvas}
                        open={open}
                        onToggleOpen={handleToggleOpen}
                        collapsed={collapsed}
                        onToggleCollapsed={handleToggleCollapsed}
                    />
                </div>
            </div>
        </nav>
    )
})
